/** Specs with a readable value of their own. Option ids are not emitted. */
const TEXT_SPECS = {
  drahtstaerke: 'Drahtstärke'
}

/**
 * Select attributes whose option label we already load for the storefront.
 * Raw option ids are skipped when the label is missing.
 */
const SELECT_SPECS = [
  'hoehe',
  'breite',
  'torhhe',
  'anzahl_torfluegel',
  'ausfuehrung_neu',
  'maschenweite',
  'material',
  'farbe',
  'elementform',
  'oberflche',
  'durchmesser',
  'pfostenart',
  'montageart',
  'breite_element',
  'hoehe_gabione'
]

function optionLabel (attribute, raw) {
  const options = attribute && attribute.options
  if (!Array.isArray(options)) return ''
  const values = Array.isArray(raw) ? raw : String(raw).split(',')
  const labels = []
  for (const value of values) {
    const option = options.find(entry => String(entry.value) === String(value).trim())
    if (option && option.label) labels.push(String(option.label).trim())
  }
  return labels.filter(Boolean).join(', ')
}

/**
 * Technical facts already stored on the product: selected variant options
 * (Höhe 103cm) and labeled attributes (Drahtstärke, Torbreite).
 */
export function productSpecProperties (product, attributesByCode) {
  if (!product) return []
  const properties = []
  const seen = new Set()
  const add = (name, value) => {
    const label = String(name || '').replace(/\s+/g, ' ').trim()
    const text = String(value || '').replace(/\s+/g, ' ').trim()
    if (!label || !text || text.length > 80) return
    const key = label.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    properties.push({
      '@type': 'PropertyValue',
      name: label,
      value: text
    })
  }

  for (const option of product.configurable_options || []) {
    const current = product[option.attribute_code]
    if (current == null || current === '') continue
    const match = (option.values || []).find(entry => String(entry.value_index) === String(current))
    if (match) add(option.label, match.label)
  }

  Object.keys(TEXT_SPECS).forEach(code => {
    const raw = product[code]
    if (raw == null || raw === '' || typeof raw === 'object') return
    add(TEXT_SPECS[code], raw)
  })

  const attributes = attributesByCode || {}
  SELECT_SPECS.forEach(code => {
    const attribute = attributes[code]
    const raw = product[code]
    if (!attribute || raw == null || raw === '') return
    const name = attribute.frontend_label || attribute.default_frontend_label
    add(name, optionLabel(attribute, raw))
  })

  return properties
}
